export default __webpack_public_path__ + "static/media/app-logo-small.30d3f13e.svg";